<template>
  <el-dialog title="更新手机号" :visible.sync="visible" width="90%" max-width="500px" :fullscreen="false" :class="{'mobile-dialog': isMobile}" @closed="handleClose">
    <el-form :model="form" :rules="rules" ref="phoneForm" label-width="100px" label-position="right">
      <el-form-item label="当前手机号">
        <div class="current-phone">{{ userProfile ? userProfile.phone || '暂无手机号' : '加载中...' }}</div>
      </el-form-item>
      
      <el-form-item label="新手机号" prop="new_phone">
        <el-input v-model="form.new_phone" placeholder="请输入新手机号"></el-input>
      </el-form-item>
      
      <el-form-item label="验证码" prop="code">
        <div class="code-input-group">
          <el-input v-model="form.code" placeholder="请输入验证码"></el-input>
          <el-button type="primary" :disabled="codeBtnDisabled" @click="sendVerificationCode">
            {{ codeBtnText }}
          </el-button>
        </div>
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="updatePhone" :loading="loading">确认更新</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PhoneDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userProfile: {
      type: Object,
      default: null
    }
  },
  data() {
    // 验证手机号格式
    const validatePhone = (rule, value, callback) => {
      const phoneRegex = /^1[3456789]\d{9}$/;
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!phoneRegex.test(value)) {
        callback(new Error('请输入正确的手机号格式'));
      } else {
        callback();
      }
    };
    
    return {
      visible: false,
      loading: false,
      codeBtnDisabled: false,
      codeBtnText: '获取验证码',
      codeCountdown: 60,
      isMobile: false,
      form: {
        new_phone: '',
        code: ''
      },
      rules: {
        new_phone: [
          { required: true, message: '请输入新手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 6, message: '验证码长度为6位', trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    value(val) {
      this.visible = val;
      if (val) {
        this.resetForm();
      }
    },
    visible(val) {
      this.$emit('input', val);
    }
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    // 重置表单
    resetForm() {
      this.form = {
        new_phone: '',
        code: ''
      };
      
      // 如果表单已被初始化，则重置校验结果
      if (this.$refs.phoneForm) {
        this.$refs.phoneForm.resetFields();
      }
    },
    
    // 处理对话框关闭
    handleClose() {
      this.resetForm();
    },
    
    // 发送验证码
    async sendVerificationCode() {
      if (!this.form.new_phone) {
        this.$message.error('请先输入新手机号');
        return;
      }
      
      try {
        this.codeBtnDisabled = true;
        
        const response = await axios.post('/api/v1/public/sms/send', {
          phone: this.form.new_phone,
          code_type: 'change'
        });
        
        if (response.data && response.data.code === 200) {
          this.$message.success('验证码发送成功，请查收短信');
          
          // 开始倒计时
          this.codeCountdown = 60;
          this.codeBtnText = `重新获取(${this.codeCountdown}s)`;
          
          const countdownInterval = setInterval(() => {
            this.codeCountdown--;
            this.codeBtnText = `重新获取(${this.codeCountdown}s)`;
            
            if (this.codeCountdown <= 0) {
              clearInterval(countdownInterval);
              this.codeBtnDisabled = false;
              this.codeBtnText = '获取验证码';
            }
          }, 1000);
          
          // 测试环境下，如果响应中包含测试验证码，则自动填充
          if (response.data.data && response.data.data.test_code) {
            this.form.code = response.data.data.test_code;
          }
        } else {
          this.$message.error('验证码发送失败：' + (response.data.msg || '未知错误'));
          this.codeBtnDisabled = false;
        }
      } catch (error) {
        console.error('验证码发送失败:', error);
        this.$message.error('验证码发送失败，请稍后重试');
        this.codeBtnDisabled = false;
      }
    },
    
    // 更新手机号
    updatePhone() {
      this.$refs.phoneForm.validate(async (valid) => {
        if (!valid) return false;
        
        // 表单验证通过，发送请求
        this.loading = true;
        
        try {
          const token = localStorage.getItem('token');
          const requestData = {
            new_phone: this.form.new_phone,
            code: this.form.code
          };
          
          const response = await axios.put('/api/v1/profile/phone', requestData, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          
          if (response.data && response.data.code === 200) {
            this.$message.success('手机号更新成功');
            this.visible = false;
            this.$emit('phone-updated', requestData.new_phone);
          } else {
            this.$message.error('手机号更新失败：' + (response.data.msg || '未知错误'));
          }
        } catch (error) {
          console.error('手机号更新失败:', error);
          let errorMsg = '手机号更新失败，请稍后重试';
          
          if (error.response && error.response.data) {
            errorMsg = error.response.data.msg || errorMsg;
          } else if (error.message) {
            errorMsg = error.message;
          }
          
          this.$message.error(errorMsg);
        } finally {
          this.loading = false;
        }
      });
    },
    
    // 检查屏幕大小
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
    }
  }
};
</script>

<style scoped>
.current-phone {
  line-height: 36px;
  font-size: 14px;
  color: #606266;
}

.code-input-group {
  display: flex;
  
  .el-input {
    flex: 1;
    margin-right: 10px;
  }
  
  .el-button {
    width: 110px;
  }
}

/* 移动端样式 */
:deep(.mobile-dialog) {
  width: 95% !important;
  max-width: 500px !important;
  margin: 0 auto !important;
  border-radius: 8px;
  overflow: hidden;
}

:deep(.el-dialog__header) {
  padding: 15px 20px;
}

:deep(.el-dialog__body) {
  padding: 15px;
}

:deep(.el-dialog__footer) {
  padding: 10px 20px;
}

@media (max-width: 768px) {
  .code-input-group {
    .el-button {
      width: 100px;
      font-size: 12px;
    }
  }
}
</style> 